import { useTranslation } from "react-i18next";

const valueItems = [
  { key: "value.item1", icon: "ri-timer-line" },
  { key: "value.item2", icon: "ri-scales-3-line" },
  { key: "value.item3", icon: "ri-refresh-line" },
  { key: "value.item4", icon: "ri-grid-line" },
];

export default function ValueSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t("value.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {valueItems.map((item) => (
            <div
              key={item.key}
              className="flex flex-col items-center text-center p-6 md:p-7 bg-background-50 rounded-xl border border-background-200/50 hover:border-primary-200/60 transition-all duration-200"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2">
                {t(`${item.key}.title`)}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {t(`${item.key}.desc`)}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
          <div className="text-center p-4">
            <p className="text-xl md:text-3xl font-heading font-bold text-primary-600">{t("social.metric1")}</p>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">{t("social.metric1.label")}</p>
          </div>
          <div className="text-center p-4">
            <p className="text-xl md:text-3xl font-heading font-bold text-accent-600">{t("social.metric2")}</p>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">{t("social.metric2.label")}</p>
          </div>
          <div className="text-center p-4">
            <p className="text-xl md:text-3xl font-heading font-bold text-primary-600">{t("social.metric3")}</p>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">{t("social.metric3.label")}</p>
          </div>
          <div className="text-center p-4">
            <p className="text-xl md:text-3xl font-heading font-bold text-accent-600">{t("social.metric4")}</p>
            <p className="text-xs md:text-sm text-foreground-500 mt-1">{t("social.metric4.label")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}